// Copyright (C) 2017-2023 Smart code 203358507

const ServicesProvider = require('./ServicesProvider');
const useServices = require('./useServices');

module.exports = {
    ServicesProvider,
    useServices
};
